import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import Fruit from '../components/Fruit'
import Fashion from '../components/Fashion'
import introduction from '../pages/introduction'  //公司简介
import introduce from '../pages/introduce'   //公司介绍
import thing from '../pages/thing'   //大事记
import news from '../pages/news'   //新闻中心
import newsDetails from '../pages/newsDetails'
import businessArea from '../pages/businessArea.vue'
import areaDetails from '../pages/areaDetails.vue'
import notice from '../pages/notice.vue'   //集团公告
import partner from '../pages/partner'   // 合作伙伴
import contact from '../pages/contact'   //联系我们
import mobIntroduce from '../pages/mobile/mobIntroduce.vue'     //手机端公司介绍
import mobNews from '../pages/mobile/mobNews.vue'   //手机端新闻中心
import mobNewsDetails from '../pages/mobile/mobNewsDetails.vue'   //手机端新闻详情
import mobBusiness from '../pages/mobile/mobBusiness.vue'
import mobBusinessDetails from '../pages/mobile/mobBusinessDetails.vue'
import mobNotice from '../pages/mobile/mobNotice.vue'
import mobPartner from '../pages/mobile/mobPartner.vue'
import mobConcact from '../pages/mobile/mobConcact.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/fruit',
            name: 'Fruit',
            component: Fruit
        },
        {
            path: '/fashion',
            name: 'Fashion',
            component: Fashion
        },
        {
            path: '/introduction',
            name: 'introduction',
            component: introduction
        },
        {
            path: '/introduce',
            name: 'introduce',
            component: introduce
        },
        {
            path: '/thing',
            name: 'thing',
            component: thing
        },
        {
            path: '/news',
            name: 'news',
            component: news
        }, 
        {
            path: '/newsDetails',
            name: 'newsDetails',
            component: newsDetails
        }, 
        {
            path: '/businessArea',
            name: 'businessArea',
            component: businessArea
        },
        {
            path: '/areaDetails',
            name: 'areaDetails',
            component: areaDetails
        },
        {
            path: '/notice',
            name: 'notice',
            component: notice
        }, 
        {
            path: '/partner',
            name: 'partner',
            component: partner
        }, 
        {
            path: '/contact',
            name: 'contact',
            component: contact
        },
        {
            path: '/mobIntroduce',
            name: 'mobIntroduce',
            component: mobIntroduce
        }, 
        {
            path: '/mobNews',
            name: 'mobNews',
            component: mobNews
        },
        {
            path: '/mobNewsDetails',
            name: 'mobNewsDetails',
            component: mobNewsDetails
        }, 
        {
            path: '/mobBusiness',
            name: 'mobBusiness',
            component: mobBusiness
        }, 
        {
            path: '/mobBusinessDetails',
            name: 'mobBusinessDetails',
            component: mobBusinessDetails
        },
        {
            path: '/mobNotice',
            name: 'mobNotice',
            component: mobNotice
        },
        {
            path: '/mobPartner',
            name: 'mobPartner',
            component: mobPartner
        },
        {
            path: '/mobConcact',
            name: 'mobConcact',
            component: mobConcact
        },
    ]
})
